export enum TransactionStatus {
    P = 'Processing',
    PA = 'Pending',
    S = 'Verified',
    F = 'Failed'
}